import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { CustomerIssuesResponseDataSchema, DataResponse, GetCustomerIssuesSchema } from "schema"
import { z } from "zod"

type Query = z.input<typeof GetCustomerIssuesSchema>
type Response = DataResponse<z.infer<typeof CustomerIssuesResponseDataSchema>>

export const getCustomerIssuesQueryKey = (query?: Query) => ["customerIssues", query]

type Props = {
  query: Query
  enabled?: boolean
}

export const customerIssuesQuery = ({ query, enabled = true }: Props) => {
  return queryOptions({
    queryKey: getCustomerIssuesQueryKey(query),
    enabled,
    queryFn: async () => {
      const response = await axios.get<Response>("/support/issues", { params: query })
      return response.data.data
    },
  })
}
